import {
  InternalPaymentsWidgetCallbacks,
  InternalPaymentsWidgetProps,
} from '../../../types/InternalPaymentsWidgetProps';
import { captureError } from '../../../utils/errorReporter';

// callbacks that are expected to be fired immediately, like input's "onChange" would
// e.g. if "onIsValidChanged" is fired with delay, TPA might not disabled "Proceed" button in time,
// and the User might be able to click on it
const reactiveCallbacks: Partial<keyof InternalPaymentsWidgetCallbacks>[] = [
  'onIsValidChanged',
];

export const guardCallbacks = (
  props: InternalPaymentsWidgetProps
): InternalPaymentsWidgetCallbacks =>
  Object.entries(props).reduce(
    (acc, [propName, propValue]) => ({
      ...acc,
      ...(typeof propValue === 'function' && {
        [propName]: reactiveCallbacks.includes(
          propName as keyof InternalPaymentsWidgetCallbacks
        )
          ? (...args) => {
              try {
                // we're interested only in sync errors (which will block our code from executing)
                propValue(...args);
              } catch (error) {
                const customErrorMessage: string = `Payments Widget: Failed to execute reactive callback "${propName}" provided by TPA`;
                console.error(customErrorMessage, error);
                captureError(error, {
                  messagePrefix: customErrorMessage,
                  fingerprint: ['react-cb-fail'],
                });
              }
            }
          : (...args) => {
              // puts callback execution in the queue, which prevents current stack execution from halting if
              // callback throws error
              setTimeout(() => {
                propValue(...args);
              });
            },
      }),
    }),
    {}
  );
